import * as React from 'react';

import { theme } from '../../../../styles/2020/theme';

import { AccordionGroup } from '../../common/AccordionGroup';
import { H2, H3, Section, Text } from '../../common/Primitives';
import { Column } from '../../layout/Column';
import { Media } from '../../layout/Media';
import { Row } from '../../layout/Row';

type TopicListsBlockProps = {
  title: string;
  items: { title: string; topics: string[] }[];
};

export function TopicListsBlock({ title, items }: TopicListsBlockProps) {
  return (
    <Section>
      <Column space={theme.space.lToXl}>
        <Row>
          <H2>{title}</H2>
        </Row>

        <Media lessThan="s">
          <AccordionGroup
            items={items.map((item) => ({
              title: item.title,
              children: item.topics.map((topic) => (
                <Text key={topic} size="s">
                  {topic}
                </Text>
              )),
            }))}
          />
        </Media>

        <Media greaterThanOrEqual="s">
          <Row align="flex-start" space={theme.space.l}>
            {items.map((item) => (
              <TopicList key={item.title} {...item} />
            ))}
          </Row>
        </Media>
      </Column>
    </Section>
  );
}

type TopicListProps = {
  title: string;
  topics: string[];
};

function TopicList({ title, topics }: TopicListProps) {
  return (
    <Column space={theme.space.xs}>
      <H3 color="green2">{title}</H3>

      <Column role="list" space={theme.space.xxxs}>
        {topics.map((topic) => (
          <Text key={topic} size="s" role="listitem">
            {topic}
          </Text>
        ))}
      </Column>
    </Column>
  );
}
